import React from "react";
import { Text, View } from "@/styles/reactnative";
import { toShortNumber } from "@utils/ciutils";

const ListVolume = ({ volume }) => {
  return null; // 거래량은 참고 이미지에 없으므로 제거
};

export default ListVolume;
